<div class="bg-[#FAFAFA] rounded-[20px] p-4 sm:p-6 space-y-6">

  <div class="flex items-center justify-between w-full">
    <h1 class="text-xl font-semibold text-[#444A6D]">
      {{ 'CREDIT_LIST.TITLE' | translate }}
    </h1>
  </div>

  <app-table
  [columns]="columns"
  [data]="data"
  [actions]="actions"
  [enablePagination]="true"
  [pageSize]="10"
>
</app-table>

</div>

<app-popup
  [(show)]="showDeletePopup"
  title="CREDIT_LIST.DELETE_TITLE"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()">
</app-popup>